import Image from 'next/image';

interface BrandWordmarkProps {
  alt?: string;
  className?: string;
  imageClassName?: string;
  priority?: boolean;
  sizes?: string;
}

export function BrandWordmark({
  alt = 'DOBIDOBI',
  className = 'relative block h-8 w-[148px]',
  imageClassName = 'object-contain object-left',
  priority = false,
  sizes = '148px',
}: BrandWordmarkProps) {
  return (
    <span className={className} aria-hidden={alt ? undefined : true}>
      <Image
        src="/logo-wordmark.png"
        alt={alt}
        fill
        priority={priority}
        unoptimized
        sizes={sizes}
        className={imageClassName}
      />
    </span>
  );
}
